import { gql } from '@apollo/client';

export const GET_ALL_COFFEE_MATCHES = gql`
  query GetAllCoffeeMatches {
    getAllCoffeeMatches {
      id
      status
      matchScore
      matchedAt
      respondedAt
      expiresAt
      emailSent
      emailSentAt
      reason
      metadata
      personAId
      personBId
      personA {
        id
        email
        profile {
          name
          firstName
          lastName
        }
        avatar {
          fileUrl
        }
        professions {
          name
        }
      }
      personB {
        id
        email
        profile {
          name
          firstName
          lastName
        }
        avatar {
          fileUrl
        }
        professions {
          name
        }
      }
      createdAt
      updatedAt
    }
  }
`;
